<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    v-cloak
    class="d-flex  align-center justify-center flex-column"
    style="height: 100%;position: relative"
  >
    <div
      style="width: 70%;max-width: 480px;"
    >
      <div class="d-flex justify-center align-center text-h3">
        {{ $t('PleaseConfirmPinActivation') }}
      </div>
      <div class="d-flex justify-center align-center mt-4">
        <v-card
          elevation="0"
          outlined
          @click="nextStep(1)"
        >
          <v-responsive :aspect-ratio="1">
            <div
              class="d-flex align-center justify-center pa-2"
              style="height: 100%"
            >
              {{ $t('ActivatePin') }}
            </div>
          </v-responsive>
        </v-card>
        <v-card
          class="ml-4"
          elevation="0"
          outlined
          @click="nextStep(0)"
        >
          <v-responsive :aspect-ratio="1">
            <div
              class="d-flex align-center justify-center pa-2"
              style="height: 100%"
            >
              {{ $t('NoPinNeeded') }}
            </div>
          </v-responsive>
        </v-card>
      </div>
      <div
        class="d-flex flex-column align-center text-caption text--secondary"
        style="width: 100%;position: absolute;left: 0;right: 0;bottom: 48px;"
      >
        <div>
          Aaden POS v {{ version }}
        </div>
        <div>
          Copyright 2023, InnerKen All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { determinedActivationStep, usePinCode } from '@/model/dataLayer/api/SaaS/user'

export default {
  name: 'UsePinCode',

  methods: {
    async nextStep (item) {
      await usePinCode(item)
      await determinedActivationStep()
    }
  }
}
</script>

<style scoped>

</style>
